// Actions
export const setCampaign = ({ commit }, payload) => {
  commit('SET_CAMPAIGN', payload)
}
export const addCampaign = ({ commit }, payload) => {
  commit('ADD_CAMPAIGN', payload)
}
export const setCampaignLoading = ({ commit }, payload) => {
  commit('SET_CAMPAIGN_LOADING', payload)
}

export const setCampaignFiles = ({ commit }, payload) => {
  commit('SET_CAMPAIGN_FILES', payload)
}
export const addCampaignFiles = ({ commit }, payload) => {
  commit('ADD_CAMPAIGN_FILES', payload)
}
export const setCampaignFilesLoading = ({ commit }, payload) => {
  commit('SET_CAMPAIGN_FILES_LOADING', payload)
}
export const setParticipantsCampaign = ({ commit }, payload) => {
  commit('SET_PARTICIPANTS_CAMPAIGN', payload)
}
export const addParticipantsCampaign = ({ commit }, payload) => {
  commit('ADD_PARTICIPANTS_CAMPAIGN', payload)
}
export const setParticipantsCampaignLoading = ({ commit }, payload) => {
  commit('SET_PARTICIPANTS_CAMPAIGN_LOADING', payload)
}

